module.exports = __webpack_public_path__ + "static/img/7.2a26815.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/7/1/zh/7.png
// module id = FUQP
// module chunks = 0